// removed by extract-text-webpack-plugin
module.exports = {"usDollarsNotice":"_3D4Ri"};